module.exports = __webpack_public_path__ + "assets/img/1201_03.jpg?65f1c5ac81573d1db4274a48ee4db855";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1201_03.jpg
// module id = 1071
// module chunks = 0